import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.scss']
})
export class CategoriesComponent implements OnInit {
  categories: any[] = [];
  addDialogOpen = false;
  editDialogOpen = false;
  categoryToEdit: any = null;

  constructor(private http: HttpClient) {}

  ngOnInit() {
    this.loadCategories();
  }

  loadCategories() {
    this.http.get<any[]>('https://testapi.ovh/api/strelstvo/categories').subscribe(
      data => this.categories = data,
      err => this.categories = []
    );
  }

  openAddDialog() {
    this.addDialogOpen = true;
    this.categoryToEdit = null;
  }

  onDialogSave() {
    this.addDialogOpen = false;
    this.editDialogOpen = false;
    this.loadCategories();
  }

  onEdit(cat: any) {
    this.categoryToEdit = { ...cat };
    this.editDialogOpen = true;
  }
}
